<template>
  <div>
    <h5 class="mb-2">{{ explanation }}</h5>
    <ParameterForm v-for="parameter in parameters" :key="parameter.key" :value="value.parameters[parameter.key]" @update:value="updateValue(parameter, $event)" :community-id="communityId" :action="actionConfig" :trigger="trigger" :parameter="parameter" :data-types="dataTypes" :errors="errors?.parameters ? errors.parameters[parameter.key] : undefined"/>
  </div>
</template>

<script>
import ParameterForm from "@/systems/modules/automation/form/actions/ParameterForm.vue";
export default {
  name: "TemplateActionForm",
  components: {ParameterForm},
  props: {
    communityId: String,
    config: Object,
    value: Object,
    explanation: String,
    errors: Object,
    dataTypes: Array,
    trigger: Object
  },
  emits: ["update:value"],
  data() {
    return {
      parameters: []
    }
  },
  mounted() {
    let list = this.actionConfig.parameters;
    list.forEach(parameter => parameter.value = this.value.parameters[parameter.key]);
    this.parameters = list.filter(item => item.value === null);
  },
  methods: {
    updateValue(parameter, value) {
      let action = JSON.parse(JSON.stringify(this.value));
      action.parameters[parameter.key] = value;
      this.$emit("update:value", action);
    }
  },
  computed: {
    actionConfig() {
      return this.config.actions.find(item => item.key === this.value.key);
    }
  }
}
</script>

<style scoped>

</style>